/* eslint-disable no-unused-vars */
import { useState } from "react";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  LogoutOutlined,
  LineChartOutlined,
  ApartmentOutlined,
  BankOutlined
} from "@ant-design/icons";
import { Layout, Menu, Button } from "antd";
const { Header, Sider, Content } = Layout;
import { Outlet, Route, Routes, useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';


import Logo from "../../Assets/Images/logo.png"

import OrgChartData from "../Screens/Electrical/Charts/TreeChart/OrgChart/OrgChartData";



function getItem(label, key, icon, children) {
  return {
    key,
    icon,
    children,
    label,
  };
}

const items = [
  getItem("TreeChart", "1", <ApartmentOutlined />),
  getItem("PlantForm", "4", <BankOutlined />),
 
//   getItem("LiveModule", "2", <LineChartOutlined />, [
//     getItem("Live Trends", "sub1"),
//     getItem("Meter Status", "sub2"),
//   ]),

]

export const NavItems = [
  { path: "/temperature-dashboard/org-chart", id: "1" },
//   { path: "/electrical-dashboard/livemodule-chart", id: "2" },
//   { path: "/electrical-dashboard/live-trends", id: "sub1" },
//   { path: "/electrical-dashboard/meter-status", id: "sub2" },
//   { path: "/electrical-dashboard/live-chart", id: "3" },
  { path: "/temperature-dashboard/plant-form", id: "4" },
];

const TemperatureLayout = ({ TempItems, TempNavItems, DefaultRoute  } ) => {
  console.log(TempItems)
  const [collapsed, setCollapsed] = useState(true);
  const navigate = useNavigate();
  const [selectedKey, setSelectedKey] = useState(
    localStorage.getItem("selectedKey") || "1"
  );

  const rs_message = useSelector((state) => state.footer.message);

  const handleMenuClick = (e) => {
    const clickedKey = e.key;
    setSelectedKey(clickedKey);
    localStorage.setItem("selectedKey", clickedKey); // Store in local storage
    const selectedItem = TempNavItems.find((item) => item.id === clickedKey);
    if (selectedItem) {
      navigate(selectedItem.path);
    }
  };

  const handleLogout = () => {
    clearTokenCookie();
    navigate("/login");
    localStorage.removeItem("selectedKey")
  };

  return (
    <Layout>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        className={`${
          collapsed ? "overflow-hidden" : "overflow-auto"
        } h-screen z-50`}
        onCollapse={(value) => setCollapsed(value)}
        style={{
          position: "sticky",
          top: 0,
          left: 0,
          bottom: 0,
          paddingRight: 4,
          paddingLeft: 4,
          background:
            "linear-gradient(165deg, rgba(49,204,17,1) 0%, rgba(23,199,75,1) 3%, rgba(3,18,68,1) 29%)",
        }}
      >
        <div className="demo-logo-vertical text-white text-2xl font-bold flex space-x-2 py-2 mb-4">
          <div
            className={`${
              collapsed ? "w-14" : "w-14"
            } p-2 ml-2 transition-all duration-300 cursor-pointer`}
            onClick={()=>navigate('/landing-page')}
          >
            {!collapsed && <div className="w-40 transition delay-200">
              <img width="100%" height="100%" src={Logo} alt="logo" />
            </div>}
          </div>
          
        </div>
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={[selectedKey]} 
          items={TempItems}
          className="bg-transparent font-bold z-50"
          onClick={handleMenuClick}
        />
      </Sider>
      <Layout className="site-layout">
        <Header className="sticky top-0 w-full bg-blue-900 z-10 shadow-md text-white">
          <i
            onClick={() => setCollapsed(!collapsed)}
            className=" cursor-pointer rounded-lg text-2xl w-8 h-8 absolute top-2 left-3 text-white"
          >
            {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          </i>
          
          <p className="text-2xl flex justify-center items-center h-16 pr-4 font-bold">
            TVS dashboard
          </p>
          <div className="flex flex-col justify-end items-center space-x-4 cursor-pointer font-semibold">
            <p className="absolute -top-4 right-8 font-bold">admin</p>
            <i
              className="text-xl absolute top-5 right-10 cursor-pointer"
              onClick={handleLogout}
            >
              <LogoutOutlined />
            </i>
          </div>
        </Header>
        <Content className="h-full">
          <div className="p-6 bg-slate-100 h-full overflow-auto">
            <Routes>
              <Route path="/" element={<DefaultRoute />} />  
              {/* <Route path="/org-chart" element={<OrgChartData />} /> */}
              {/* <Route path="/combined-chart" element={<CombinedChart />} /> */}
              {/* <Route path="/live-chart" element={<LiveChartCard />} /> */}
              {/* <Route path="/plant-form" element={<PlantForm />} /> */}
            </Routes>
            <Outlet />
          
          </div>
        
          
        </Content>
  <div className="min-h-fit">
            <div className="h-5 bg-blue-900">
              <p className=" font-mono text-sm text-white">{rs_message}</p>
            </div>
          </div>

      </Layout>

    </Layout>


  );
};
export default TemperatureLayout;
